import type { SystemStyleObject } from '@/styled-system/types';
import { Box, Gleam, VisuallyHidden } from '@zillow/constellation-10';

type UnreadIndicatorProps = {
  count?: number;
  dataTestId?: string;
  css?: SystemStyleObject;
};

export default function UnreadIndicator({ count, dataTestId = '', css }: UnreadIndicatorProps) {
  return (
    // Gleam.Root floats its label once it has a second child; this positioned span holds the sr-only text.
    <Box asChild css={{ display: 'inline-flex', position: 'relative' }}>
      <span>
        <Gleam.Root>
          <Gleam.Label
            appearance="dot"
            // Required by Gleam.Label but never rendered in dot appearance; the announcement
            // below is what reaches assistive tech.
            count={count ?? 0}
            renderDot={({ ref: _ref, ...dotProps }) => <Gleam.Dot {...dotProps} />}
            tone="default"
            data-testid={dataTestId}
            css={css}
          />
        </Gleam.Root>
        <VisuallyHidden>{count === undefined ? 'New message(s)' : `${count} New message(s)`}</VisuallyHidden>
      </span>
    </Box>
  );
}
